import React from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon  from "@mui/icons-material/Work";
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export type GraphData = {
    displayName: string,
    jobTitle: string,
    mail: string,
    businessPhones: string[],
    officeLocation: string,
    department: string,
    companyName: string
};

export const ProfileData: React.FC<{graphData: GraphData}> = ({graphData}) => {
    return (
        <Stack direction="row" flexWrap="wrap" gap={3} className="profileData">
            <ProfileField icon={<PersonIcon />} label="Name" value={graphData.displayName} />
            <ProfileField icon={<WorkIcon />} label="Title" value={graphData.jobTitle} />
            <ProfileField icon={<MailIcon />} label="Mail" value={graphData.mail} />
            <ProfileField icon={<PhoneIcon />} label="Phone" value={graphData.businessPhones[0]} />
            <ProfileField icon={<LocationOnIcon />} label="Location" value={graphData.officeLocation} />
        </Stack>
    );
};

// A single compact icon + label + value tile — sized to its content (not full row width) so
// ProfileData's items wrap horizontally instead of stacking as full-width list rows.
const ProfileField: React.FC<{icon: React.ReactNode, label: string, value: string}> = ({icon, label, value}) => (
    <Box display="flex" alignItems="center" gap={1.5} sx={{ minWidth: 220 }}>
        <Avatar sx={{ width: 36, height: 36 }}>{icon}</Avatar>
        <Box>
            <Typography variant="body2" color="text.secondary">{label}</Typography>
            <Typography variant="body1">{value}</Typography>
        </Box>
    </Box>
);
